import { OrbitSuccess } from '#components/atoms/illustrations/OrbitSuccess.tsx';
import { AuthLayout } from '#components/patterns/layouts/auth/AuthLayout.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';

export function DeletionSuccess() {
  return (
    <AuthLayout>
      <CenteredLayout Illustration={OrbitSuccess}>
        <h1 className="h2">Your account has been deleted</h1>
        <p className="p color-lowlight text-center">
          Thanks for trying Managed Nebula. We’re sorry to hear things didn’t work out but wish you all the best.
        </p>
      </CenteredLayout>
    </AuthLayout>
  );
}
